import React from "react"
import { SubscriptionButton } from "./SubscriptionButton"
import plans from "../../../functions/plans"
import { PADDOCK_PASS_REQUIRED_MESSAGE } from "../../utils/racingLineEntitlement"
import { trackEvent } from "../../utils/analytics"

export const SubscriptionWall = ({
    onClose,
    title,
    message,
    ctaText = "Subscribe — $9.99/month",
    intent = "unknown",
}) => {
    const wallTitle = title || "Unlock Paddock Pass Features"
    const wallMessage =
        message ||
        `${PADDOCK_PASS_REQUIRED_MESSAGE} Your subscription starts immediately and payment details are collected securely by Stripe.`
    const sample =
        intent === "iracing_import"
            ? {
                  href: "/iracing-coaching-report/",
                  label: "Explore the iRacing analysis",
              }
            : intent === "alfano_import"
            ? {
                  href: "/alfano-coaching-report/",
                  label: "Explore the Alfano analysis",
              }
            : null
    const telemetryProduct = intent.startsWith("iracing_")
        ? "iracing"
        : intent.startsWith("alfano_")
        ? "alfano"
        : intent.startsWith("gopro_")
        ? "gopro"
        : "unknown"
    return (
        <div className="fixed inset-0 bg-black/50 z-[9998] flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 space-y-4">
                <h3 className="text-xl font-semibold">{wallTitle}</h3>
                <p className="text-gray-600">{wallMessage}</p>
                {sample && (
                    <div className="rounded-xl border border-[#d9dcec] bg-[#f6f7fc] px-4 py-3">
                        <p className="text-xs font-bold uppercase tracking-widest text-[#5159a2]">
                            See what the analyzer can do
                        </p>
                        <a
                            className="mt-1 block font-semibold text-[#333b78] underline underline-offset-2"
                            href={sample.href}
                            onClick={() =>
                                trackEvent("telemetry_analysis_open", {
                                    product: telemetryProduct,
                                    placement: "subscription_wall",
                                    intent,
                                })
                            }
                        >
                            {sample.label}
                        </a>
                    </div>
                )}
                <SubscriptionButton
                    priceId={plans.paddockPass.stripePriceId}
                    buttonText={ctaText}
                    checkoutIntent={intent}
                    className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 hover:text-blue-200 transition font-semibold"
                />
                <div className="rounded-lg bg-gray-50 border border-gray-200 px-4 py-3 text-sm text-gray-600 space-y-1">
                    <p>
                        <strong className="text-gray-800">
                            $9.99/month, charged today.
                        </strong>{" "}
                        No trial period.
                    </p>
                    <p>
                        Secure checkout by Stripe. Open Racer never stores your
                        card details.
                    </p>
                    <p>
                        Cancel anytime. Your existing racing lines stay yours.
                    </p>
                </div>
                <a
                    className="block text-center text-sm text-blue-700 underline"
                    href="/pricing"
                    onClick={() =>
                        trackEvent("pricing_open", {
                            product: "paddock_pass",
                            placement: "subscription_wall",
                            intent,
                        })
                    }
                >
                    See full pricing and what is included
                </a>
                <button
                    className="w-full py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 transition font-semibold rounded-lg"
                    onClick={onClose}
                >
                    Not now
                </button>
            </div>
        </div>
    )
}

export default SubscriptionWall
